import { createFileRoute } from "@tanstack/react-router"

import { breadcrumbJsonLd, buildHead } from "@/core/seo"

import { ProductPage } from "../../components/landing"
import { INVOICING_ZH, INVOICING_SEO_ZH } from "../../content/zh/products/invoicing"

/** Chinese version of /invoicing (D-WEB-LANG-SCOPE); the English route carries the hreflang pair too. */
export const invoicingZhSeo = () =>
  buildHead({
    ...INVOICING_SEO_ZH,
    path: INVOICING_ZH.path,
    localePrefix: "zh",
    jsonLd: [breadcrumbJsonLd([{ name: "首页", path: "/zh" }, { name: INVOICING_ZH.name }])],
  })

export const Route = createFileRoute("/_brand-layout/zh/invoicing")({
  head: () => {
    const { meta, links, scripts } = invoicingZhSeo()
    return { meta, links, scripts }
  },
  component: InvoicingZhPage,
})

export function InvoicingZhPage() {
  return <ProductPage content={INVOICING_ZH} />
}
